export const GET_SUBJECTS = 'GET_SUBJECTS';
export const GET_SUBJECTS_SUCCESS = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_ERROR = 'GET_SUBJECTS_ERROR';

export const ADD_NEW_SUBJECT = 'ADD_NEW_SUBJECT';
